<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_">保费试算</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item" style="justify-content: flex-start">
              <label>保障期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  <a-radio-group v-model="guapre" @change="e => changeData(e.target.value, 'BZQJa')">
                    <a-radio :disabled="disabledAll || (item.key < 6 && guarantPreDisabled)" v-for="item in guarantPre" :key="item.key" :value="item.key"> {{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div>
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
            </div>
            <div class="form_item">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                  <label>
                    {{ item.occupationKind }}
                  </label>
                  <a-input-number :min="0" :disabled="disabledAll" v-model="item.personNum" @change="value => changeData(value, 'TBZYa')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div class="form_items">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div class="check_item" style="margin-left: 40px">
                  <a-radio-group :disabled="disabledAll" name="radioGroup" :default-value="0" v-model="countData.SFSGa" @change="e => changeData(e.target.value, 'SFSGa')">
                    <a-radio :value="0">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <div class="flex_ mar_bottom">
            <label><span class="red">*</span>投保企业名称：</label>
            <div class="right_">
                <a-input style="width: 300px" :disabled="disabledAll" v-model="countData.name" @change="e => changeData(e.target.value, 'name')"></a-input>
            </div>
        </div>
        <p class="p-header">主险</p>
        <!-- 意外伤害身故及残疾保险金 -->
        <div class="form_item">
          <label>意外伤害身故及伤残保险金</label>
          <div class="right_">
            <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" @change="value => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗费用 -->
          <div class="form_item">
            <label>意外伤害医疗费用（社保范围内0免赔100%报销）</label>
            <div class="right_">
              <a-select :disabled="disabledAll" placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YLFY" @change="value => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index" :value="item.value" :disabled="item.disabled">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 扩展社保外医疗费用 -->
          <div class="form_item">
            <label>扩展社保外医疗费用（100元免赔80%报销，以意外医疗保额10%为上限，共用保额)</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="countData.YLFY === 0 || disabledAll" v-model="countData.ZFYF" @change="value => changeData(value, 'ZFYF')">
                <a-select-option v-for="(item, index) in ZFYFOptions" :key="item.value + 'ZFYF' + index" :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外住院津贴责任 -->
          <div class="form_item">
            <label>意外住院津贴（3天免赔，单次最长90天，累计180天）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" :disabled="disabledAll" class="select_" v-model="countData.ZYJT" @change="value => changeData(value, 'ZYJT')">
                <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 公共交通工具意外身故/伤残（火车、轮船、轨道交通） -->
          <div class="form_item">
            <label>公共交通工具意外身故/伤残（火车、轮船、轨道交通）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" v-model="countData.YCXSCa" :disabled="disabledAll" @change="value => changeData(value, 'YCXSCa')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'YCXSCa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 公共交通工具意外身故/伤残（民航客机） -->
          <div class="form_item">
            <label>公共交通工具意外身故/伤残（民航客机）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.SHHLa" @change="value => changeData(value, 'SHHLa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'SHHLa'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 营运汽车意外身故/伤残 -->
          <div class="form_item">
            <label>营运汽车意外身故/伤残</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.KYLCYW" @change="value => changeData(value, 'KYLCYW')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'KYLCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 非营运汽车意外身故/伤残（7座以下非营运汽车） -->
          <div class="form_item">
            <label>非营运汽车意外身故/伤残（7座以下非营运汽车）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="disabledAll" v-model="countData.KYQCYW" @change="value => changeData(value, 'KYQCYW')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'KYQCYW'" :value="item.value"> {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">
          <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" @click="goplicy" v-if="!agreementRead"> 完成报价，立即投保</a-button>
          <a-button class="calBtn_" type="primary" @click="countPremiumSum" :disabled="disabledAll">刷新试算</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
import DATA from './../js/data';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      productCode: '',
      plan: '',
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      guapre: 12,
      //保障期间
      guarantPre: this.$lodash.cloneDeep(DATA.guarantPre),
      premiumSum: 0, //总保费
      // 扩展残疾鉴定国家工伤标准
      KZSCOptions: [
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 1,
          name: '附加'
        }
      ],
      // 飞机意外伤害身故和残疾  // 火车意外伤害身故和残疾 //轮船意外伤害身故和残疾
      oneSCOptions: DATA.oneSCOptions, //汽车意外伤害身故和残疾
      KYQCYWOptions: DATA.KYQCYWOptions,
      // 测算要提交的数据
      countData: {
        BZQJa: 12, //保障期间?
        TBZYa: 0, //投保职业?
        SFSGa: 0, //是否涉高
        name: '', //投保人名称
        SWCJ: 100000, //意外伤害身故、残疾
        YLFY: 0, //意外医疗费用
        ZFYF: 0, //自费药费用
        ZYJT: 0, //意外住院津贴
        YCXSCa: 0, // 公共交通工具意外（火车轮船轨道交通）
        SHHLa: 0, // 公共交通工具意外（民航客机）
        KYLCYW: 0, //搭乘营运汽车意外
        KYQCYW: 0 //自驾车驾乘人员意外（7座以下非营运车辆）
      },
      //提交data
      data: {
        architecture: 0, //是否是建筑行业
        riskInfos: [],
        salPolicy: {
          productCode: '', //产品code
          bracket: 12, //保费期限
          planCode: ''
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
        },
        premiumBaseDtoList: [] //人数
      },
      planType: 'A',
      occupationNumberList: DATA.occupationNumberList,
      exist456: false // 含4,5, 6类职业
    };
  },
  computed: {
    // 含4-5类职业、涉高作业则最短6个月起  TODO
    guarantPreDisabled() {
      let valid = this.exist456 || this.countData.SFSGa == '1';
      return valid;
    },
    // 意外伤害身故、残疾
    SWCJOptions() {
        let occupationList = []
        this.occupationNumberList.map(item => {
            if(item.personNum > 0) {
                occupationList.push(item.occupationKind)
            }
        });
        
      // 1个月限制主险保额40万。1-2类保额：10万-100万； 3-4类保额：10万-60万； 5-6类保额：10万-50万
      let Options = DATA.SWCJOptions;
      if (this.guapre == 1) {
        return Options.filter(item => item.value <= 400000);
      } else if (occupationList.indexOf('5类') > -1 || occupationList.indexOf('6类') > -1) {
        return Options.filter(item => item.value <= 500000);
      } else if(occupationList.indexOf('3类') > -1 || occupationList.indexOf('4类') > -1) {
        return Options.filter(item => item.value <= 600000);
      } else {
        return Options;
      }
    },
    // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
    ZFYFOptions() {
      let Options = [
        //自费药费用(即保司系统自费药)选择框
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 1,
          name: '附加'
        }
      ];
      return Options;
    },
    // 意外伤害医疗费用
    YLFYOptions() {
      let option = DATA.YLFYOptions;
      let SWCJ = this.countData.SWCJ; // 主险保额
      // 1万至身故保额的20%
      return option.filter(item => item.value <= SWCJ * 0.2);
    },
    // 意外住院津贴
    ZYJTOptions() {
      let ZYJTOptions = [
        //意外住院津贴责任 : ZYJT
        {
          value: 0,
          name: '不附加'
        },
        {
          value: 50,
          name: '50元/天'
        },
        {
          value: 100,
          name: '100元/天'
        }
      ];
      return ZYJTOptions;
    },
    // 选的总投保人数
    totalNumber() {
      let num = 0;
      this.occupationNumberList.forEach(e => {
        num += Number(e.personNum);
      });
      return parseInt(num);
    },
    // 险种的数组
    riskInfos() {
      let infos = [
        {
          riskCode: '0050', //意外伤害身故及残疾保险金
          amount: this.countData.SWCJ,
          riskName: `意外伤害身故及残疾保险金`
        },
        {
          riskCode: '0051', // 意外伤害医疗
          amount: this.countData.YLFY,
          riskName: `意外伤害医疗费用`
        },
        {
          riskCode: '00452', //扩展社保外医疗费用
          amount: this.countData.ZFYF == '0' ? 0 : this.countData.YLFY,
          riskName: `扩展自费药`
        },
        {
          riskCode: '0547', //意外伤害住院津贴
          amount: this.countData.ZYJT * 180,
          riskName: `意外伤害住院津贴`
        },
        {
          riskCode: '01421', //公共交通工具意外身故/伤残（火车、轮船、轨道交通）
          amount: this.countData.YCXSCa,
          riskName: `公共交通工具意外身故/伤残（火车、轮船、轨道交通）`
        },
        {
          riskCode: '01376', //公共交通工具意外身故/伤残（民航客机）
          amount: this.countData.SHHLa,
          riskName: `公共交通工具意外身故/伤残（民航客机）`
        },
        {
          riskCode: '01379', //营运汽车意外身故/伤残
          amount: this.countData.KYLCYW,
          riskName: `营运汽车意外身故/伤残`
        },
        {
          riskCode: '01380', //非营运汽车意外身故/伤残（7座以下非营运汽车）
          amount: this.countData.KYQCYW,
          riskName: `非营运汽车意外身故/伤残（7座以下非营运汽车）`
        }
      ];
      return infos;
    }
  },
  watch: {
    'countData.YLFY'(val) {
      if (!val) {
        this.countData.ZFYF = 0;
      }
    }
  },
  created() {
    const { p } = this.$route.query;
    this.productCode = p;
    this.plan = p;
    this.$store.commit('setagreementRead', this.disabledAll);
  },
  mounted() {
    this.countData.SFSGa = 0;
    this.$bus.$on('busGuapre', data => {
      //涉高
      this.guapre = data;
    });
    this.$bus.$on('busStature', data => {
      //涉高
      this.countData.SFSGa = data - 0;
    });
    this.$bus.$on('busRiskInfos', data => {
      //险种信息 附指   保单详情中的险种信息
      let obj = this.$lodash.cloneDeep(this.countData);
      data.forEach(e => {
        if (e.riskCode == '0050') obj.SWCJ = e.amount - 0;
        if (e.riskCode == '0051') obj.YLFY = e.amount - 0;
        if (e.riskCode == '00452') obj.ZFYF = e.amount - 0 > 0 ? 1 : 0;
        if (e.riskCode == '0547') obj.ZYJT = (e.amount - 0)/180;
        if (e.riskCode == '01421') obj.YCXSCa = e.amount - 0;
        if (e.riskCode == '01376') obj.SHHLa = e.amount - 0;
        if (e.riskCode == '01379') obj.KYLCYW = e.amount - 0;
        if (e.riskCode == '01380') obj.KYQCYW = e.amount - 0;
      });
      
      this.countData = { ...obj };
      this.changeData();
    });
    if(!this.$route.query.policyId) {
      this.$nextTick(() => {
        this.changeData('BZQJa', 12, 'init')
      })
    }
  },
  beforeDestroy() {
    this.$bus.$off('busUserBol');
  },
  methods: {
    // 改变试算的数据
    changeData(value, param) {
      this.countData[param] = value;
      let exist456 = false;
      let premiumBaseDtoList = this.occupationNumberList.filter(item => {
        let valid = item.personNum > 0;
        if (valid && (item.occupationKind.indexOf('4') > -1 || item.occupationKind.indexOf('5') > -1 || item.occupationKind.indexOf('6') > -1 )) {
            exist456 = true;
        }
        return valid;
      });
    // 若含4-5类职业、涉高作业则最短6个月起。1个月限制主险保额40万
      this.exist456 = exist456;
      if ((exist456 || this.countData.SFSGa == '1') && Number(this.countData.BZQJa.toString()) < 6) {
        this.guapre = 6;
        this.countData.BZQJa = 6;
      }
      this.data = {
        riskInfos: this.riskInfos, //险种信息
        salPolicy: {
          productCode: this.productCode, //产品code
          bracket: this.countData.BZQJa.toString(), //保费期限
          planCode: this.productCode,
          discountfactor: 1,
          name: this.countData.name
        },
        salPolicyExt: {
          isworkheightinvolved: this.countData.SFSGa.toString() //是否高空（0-否，1-是）
        },
        salPolicyHolder: {
          name: this.countData.name,
          addfifty: '1' // 测算类型
        },
        premiumBaseDtoList //人数
      };
      let arrData = this.$lodash.cloneDeep(this.data);
      delete arrData['premiumBaseDtoList']; //投保职业人数是不参与下面的计算的
      if(param  === 'SWCJ' && this.countData.YLFY > this.countData.SWCJ * 0.2) {
        this.countData.YLFY = this.countData.SWCJ * 0.2
      }
      if (param != 'TBZYa') {
        this.$bus.$emit('onRiskInfos', arrData);
      }
    },
    //保费试算
    countPremiumSum(e) {
      e.preventDefault();
      this.data.salPolicyHolder.addfifty = '1';
      this.form.validateFields(err => {
        if (!err) {
          
          if (!this.totalNumber) {
            this.premiumSum = 0;
            this.$message.warning('请选择投保人数');
            return;
          }
          // 5人起，若含4-5类职业、涉高作业则最低10人起
          if (Number(this.totalNumber) < 3) {
            this.premiumSum = 0;
            this.$message.warning('最低投保人数最低3人');
            return;
          }
       
          this.$api.calPremiumEmployer(this.data).then(res => {
            if (res.data.success) {
              let data = res.data.content;
              this.premiumSum = data.totalPremium;
              
            } else {
              this.$message.error(res.data.returnMsg + '错误');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.red {
    color: red;
}
.calTxt_ {
  font-size: 18px !important;
  font-weight: bold !important;
  color: #666666;
}

.pre-box {
  margin-top: 15px;
}

.form_items {
  display: flex;
  width: 100%;
  color: #333;
  margin-bottom: 10px;
}

.risk_ {
  width: 60%;
}
.mar_bottom {
    margin-bottom: 20px;
}
.btn_list {
  margin-top: 20px;
  display: flex;

  .calBtn_ {
    margin-right: 30px;
  }
}

.flex_ {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  label {
    color: #333;
  }
}

.form_item {
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: #333;
  margin-bottom: 10px;

  &.width_50 {
    width: 50%;
  }

  &.width_40 {
    width: 40%;
  }

  &.width_60 {
    width: 60%;
  };

  > label {
    width: 400px;
    white-space: wrap;
    margin-right: 10px;
    margin-top: 15px;
  }

  .right_ {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    .select_ {
      margin-top: 10px;
    }

    .check_item {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-top: 10px;

      &.on {
        label {
          border-color: #fe8f2d;
        }
      }

      label {
        // border: 1px solid #d9d9d9;
        padding: 3px 10px;
        border-radius: 3px;
        margin-right: 5px;
      }

      &.s_input input {
        width: 40px;
      }
    }
  }
}

.p-header {
  width: 100%;
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 0;
}
</style>
